import { Heading } from 'src/components/Heading';
import { ListDncNumbers } from './components/ListDncNumbers';

export const ManageDnc = () => {
  return (
    <div className="flex-1">
      <Heading
        title="Do Not Call (DNC) Numbers"
        subtitle="Manage phone numbers that should not be called"
      />

      <ListDncNumbers />
    </div>
  );
};
